var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tabs",
    {
      staticClass: "rounded-lg d-flex flex-column max-width",
      style: { backgroundColor: _vm.backgroundColor },
      attrs: {
        centered: _vm.centered,
        "background-color": _vm.backgroundColor,
        grow: _vm.grow,
        eager: false,
        height: _vm.height,
        color: "primary",
      },
      model: {
        value: _vm.tab,
        callback: function ($$v) {
          _vm.tab = $$v
        },
        expression: "tab",
      },
    },
    [
      _c("v-tabs-slider", {
        staticStyle: { "min-width": "50px" },
        attrs: { color: "primary" },
      }),
      _vm._l(_vm.items, function (item, n) {
        return [
          _c(
            "v-tab",
            {
              key: n + 1,
              staticClass: "text-capitalize text-body-2 text-no-wrap",
              attrs: { ripple: false, href: "#tab-" + (n + 1) },
            },
            [
              _c(
                "v-badge",
                {
                  attrs: {
                    color: "primary",
                    content: _vm.isLoading
                      ? "..."
                      : _vm.totalCount
                      ? _vm.totalCount[n]
                      : "",
                  },
                  model: {
                    value: _vm.showBadge,
                    callback: function ($$v) {
                      _vm.showBadge = $$v
                    },
                    expression: "showBadge",
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.closeTranslate ? item : _vm.$t(item)) + " "
                  ),
                  !_vm.showBadge && _vm.totalCount
                    ? [
                        !_vm.isLoading || _vm.tab != "tab-" + (n + 1)
                          ? _c("span", { staticClass: "text--secondary" }, [
                              _vm._v(" (" + _vm._s(_vm.totalCount[n]) + ")"),
                            ])
                          : _vm.isLoading && _vm.tab == "tab-" + (n + 1)
                          ? _c("v-progress-circular", {
                              attrs: {
                                size: _vm.height ? Number(_vm.height) / 2 : 20,
                                width: 2,
                                color: "primary",
                                indeterminate: "",
                              },
                            })
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ]
      }),
      !_vm.grow && !_vm.centered
        ? [
            _c(
              "v-container",
              {
                staticClass:
                  "\n        transparent\n        py-0\n        ma-0\n        px-2\n        d-flex\n        align-center\n        justify-end\n        flex-row\n      ",
                attrs: { fluid: "" },
              },
              [
                _vm._l(_vm.items, function (item, n) {
                  return [
                    _vm._t("filter-content-" + (n + 1), null, {
                      filter: _vm.onFilter,
                    }),
                  ]
                }),
              ],
              2
            ),
          ]
        : _vm._e(),
      _vm.showTab
        ? _c(
            "v-tabs-items",
            {
              staticClass: "rounded-lg max-width transparent",
              class: _vm.border ? "" : "mt-3",
              attrs: { continuous: "" },
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            _vm._l(_vm.items, function (item, n) {
              return _c(
                "v-tab-item",
                {
                  key: n + 1 + "-content",
                  staticClass: "max-width",
                  attrs: { value: "tab-" + (n + 1) },
                },
                [
                  _vm.border ? _c("v-divider") : _vm._e(),
                  _c(
                    "v-card",
                    {
                      staticClass: "pa-0 rounded-lg",
                      class: _vm.contentBackground,
                      attrs: { elevation: 0, overlap: "" },
                    },
                    [
                      _c(
                        "v-card-text",
                        {
                          class:
                            (_vm.special ? "pa-0 " : " pa-8 ") +
                            _vm.contentBackground,
                        },
                        [_vm._t("content-" + (n + 1))],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }